<div class="title-large" style="display: flex;align-items: center; gap: 8px;margin-bottom: 24px">
  <span (click)="drawer.close()" class="material-symbols-rounded" style="cursor: pointer;padding: 6px">west</span>
  Previous messages
</div>

<mat-tab-group style="width: 600px;background: var(--background)">

  <mat-tab label="Favorites">
    <div style="height: 24px"></div>
    @for (message of favoritesMessages(); track message) {

      <div class="title-small"
           style="margin-bottom: 8px;font-weight: 500">{{ message.created|date:"dd MMM yyy HH:mm" }}
      </div>

      <div data-testid="favorites-message" class="message-container">
        <div class="title-small" style="margin-bottom: 12px">{{ message.titles[0] }}</div>
        <div class="body-large" style="margin-bottom: 12px">{{ message.messages[0] }}</div>
        @if (message.labels[0].length) {
          <div class="body-large"
               style="margin-bottom: 12px;font-weight: 500;color: var(--primary)">
            <span [matTooltip]="message.externalUrl">{{ message.labels[0] }}</span>
          </div>
        }
        <span data-testid="messageOptions" [matMenuTriggerFor]="menu" class="material-symbols-rounded"
              style="position:absolute;right:8px;top:8px;cursor: pointer">more_vert</span>
        <mat-menu #menu="matMenu" class="test-me">
          <button data-testid="deleteMessage" mat-menu-item (click)="delete(message)">Delete</button>
          <button data-testid="copyMessage" mat-menu-item (click)="copyMessage.emit(message)">Copy</button>
        </mat-menu>

      </div>
    }
  </mat-tab>
  <mat-tab label="History">

    <div style="height: 24px"></div>
    @for (message of historyMessages(); track message) {


      <div class="title-small"
           style="margin-bottom: 8px;font-weight: 500">{{ message.created|date:"dd MMM yyy HH:mm" }}
      </div>

      <div data-testid="history-message" class="message-container">
        <div class="title-small" style="margin-bottom: 12px">{{ message.titles[0] }}</div>
        <div class="body-large" style="margin-bottom: 12px">{{ message.messages[0] }}</div>
        @if (message.labels[0]?.length) {
          <div class="body-large"

               style="margin-bottom: 12px;font-weight: 500;color: var(--primary)">
            <span [matTooltip]="message.externalUrl">{{ message.labels[0] }}</span>
          </div>
        }
        <span data-testid="historyMessageOptions" [matMenuTriggerFor]="menu" class="material-symbols-rounded"
              style="position:absolute;right:8px;top:8px;cursor: pointer">more_vert</span>
        <mat-menu #menu="matMenu" class="test-me">
          <button data-testid="addToFavorites" mat-menu-item (click)="addToFavorites(message)">Add to favorites</button>
        </mat-menu>

      </div>
    }

  </mat-tab>

</mat-tab-group>



